import Cookies from 'js-cookie';

const rawCookies = Cookies.withConverter({ read: (value: string) => value });

/**
 * All cookies with their values left exactly as stored (still URL-encoded).
 * Form tracking URLs have always carried the _uc_* values this way.
 */
export const readRawCookies = (): Record<string, string> =>
    typeof document === 'undefined' ? {} : rawCookies.get();
